export const UPDATE_SEARCH = 'UPDATE_SEARCH';

export interface UpdateSearchActions {
	type: typeof UPDATE_SEARCH;
	payload: any | null;
}

export type SearchActions = UpdateSearchActions;
